var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.availableFields,
      "item-text": "label",
      "item-value": "value",
      "label": "Field",
      "dense": "",
      "outlined": "",
      "hide-details": ""
    },
    on: {
      "change": _vm.onFieldChange
    },
    model: {
      value: _vm.localCondition.field,
      callback: function callback($$v) {
        _vm.$set(_vm.localCondition, "field", $$v);
      },
      expression: "localCondition.field"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('filter-operator-select', {
    attrs: {
      "operators": _vm.operators
    },
    on: {
      "change": _vm.onOperatorChange
    },
    model: {
      value: _vm.localCondition.operator,
      callback: function callback($$v) {
        _vm.$set(_vm.localCondition, "operator", $$v);
      },
      expression: "localCondition.operator"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": _vm.hasTwoValues ? 2 : 5
    }
  }, [_c('filter-value-input', {
    attrs: {
      "field": _vm.currentField,
      "operator": _vm.localCondition.operator
    },
    model: {
      value: _vm.localCondition.value,
      callback: function callback($$v) {
        _vm.$set(_vm.localCondition, "value", $$v);
      },
      expression: "localCondition.value"
    }
  })], 1), _vm.hasTwoValues ? _c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('filter-value-input', {
    attrs: {
      "field": _vm.currentField,
      "operator": _vm.localCondition.operator,
      "is-second-value": true
    },
    model: {
      value: _vm.localCondition.value2,
      callback: function callback($$v) {
        _vm.$set(_vm.localCondition, "value2", $$v);
      },
      expression: "localCondition.value2"
    }
  })], 1) : _vm._e(), _c('v-col', {
    attrs: {
      "cols": "1"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('remove');
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }